export const MAP_SIZE = 5000;
export const MAP_WIDTH = 5000;   // ✅ 추가
export const MAP_HEIGHT = 2872;  // ✅ 추가

export const PLAYER_SIZE = 200;
export const PLAYER_SPEED = 5;
export const GRID_SPACING = 100;
export const ZONE_SIZE = 500;